export default __webpack_public_path__ + "static/media/successMobile_bg.7c400cca.png";